import { useContext } from 'react';
import { ApolloProvider, getApolloContext } from '@apollo/client';
export { ApolloConsumer, ApolloProvider, DocumentType, createQueryPreloader, getApolloContext, operationName, parser, skipToken, useApolloClient, useBackgroundQuery, useFragment, useLazyQuery, useLoadableQuery, useMutation, useQuery, useQueryRefHandlers, useReactiveVar, useReadQuery, useSubscription, useSuspenseQuery } from '@apollo/client/react';
export function useGraphQLClient() {
  const {
    client
  } = useContext(getApolloContext());
  return client;
}
export const GraphQLProvider = ApolloProvider;
//# sourceMappingURL=react.js.map